module.exports = __webpack_public_path__ + "static/media/question-square.164fdf95.svg";